/**
 * TPL Accordion FX — motion.dev "Accordion" port for every <details> that
 * holds an .accordion__content (PDP accordions, FAQ, drawers). Opening eases
 * the content height with a fade instead of the native jump; closing animates
 * back before the element actually closes. Native behaviour under reduced
 * motion or without the Web Animations API.
 */
(function () {
  'use strict';

  var EXPO = 'cubic-bezier(0.16, 1, 0.3, 1)';
  var OPEN_MS = 480;
  var CLOSE_MS = 300;

  function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }
  function supported() {
    return typeof Element !== 'undefined' && typeof Element.prototype.animate === 'function';
  }

  function init(details) {
    if (details.dataset.tplAccFx === '1') return;
    var summary = details.querySelector(':scope > summary');
    var content = details.querySelector(':scope > .accordion__content');
    if (!summary || !content) return;
    details.dataset.tplAccFx = '1';
    var busy = false;

    summary.addEventListener('click', function (e) {
      if (!supported() || reducedMotion()) return;   // native toggle
      e.preventDefault();
      if (busy) return;
      busy = true;
      content.style.overflow = 'hidden';
      if (details.open) {
        var h0 = content.offsetHeight;
        content.animate([{ height: h0 + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: CLOSE_MS, easing: EXPO }).onfinish = function () {
          details.open = false;
          content.style.overflow = '';
          busy = false;
        };
      } else {
        details.open = true;
        var h1 = content.offsetHeight;
        content.animate([{ height: '0px', opacity: 0 }, { height: h1 + 'px', opacity: 1 }], { duration: OPEN_MS, easing: EXPO }).onfinish = function () {
          content.style.overflow = '';
          busy = false;
        };
      }
    });
  }

  function boot() { document.querySelectorAll('details').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('load', boot);

  window.TPLAccordionFx = { init: init };
})();
